export const TASKS_SUB_PAGES = {
  tasks: 'tasks',
};
